import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '@/assets/home/logo.png';
import logoWhiteImg from '@/assets/home/logo-white.png';
import { MenuOutlined } from '@ant-design/icons';
import './index.css';

const Header = (props) => {
  const pageName = props.pageName;
  const navigate = useNavigate();
  const [menuShow, setMenuShow] = useState(false);
  const [productOpen, setProductOpen] = useState(true); // 控制产品展开/收起
  const menuRef = useRef(null);
  const menuIconRef = useRef(null);

  const goPage = (path) => {
    navigate(path);
    setMenuShow(false);
  };

  const showMenu = () => {
    setMenuShow(!menuShow);
  };

  const handleOutsideClick = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !menuIconRef.current.contains(event.target)
    ) {
      setMenuShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  console.log('pageName', pageName);

  return (
    <>
      <div className="mTopTabs">
        <div className="top-flex">
          <img
            alt=""
            src={
              pageName === 'home' || pageName === 'resultGs'
                ? logoImg
                : logoWhiteImg
            }
            className="top-logo"
          />
          <div
            className="logo-name"
            style={
              pageName === 'home' || pageName === 'resultGs'
                ? {}
                : { color: '#ffffff' }
            }
          >
            鸿凯瑞达
          </div>
        </div>
        <div style={{ marginTop: '3vh' }}>
          <MenuOutlined
            style={{
              fontSize: '1.5rem',
              color:
                pageName === 'home' || pageName === 'resultGs'
                  ? '#1549D0'
                  : '#ffffff',
              marginRight: '4vw',
            }}
            onClick={() => showMenu()}
            ref={menuIconRef}
          />
        </div>
      </div>

      {/* 菜单 */}
      <div
        ref={menuRef}
        className={`menu-div ${!menuShow ? 'menu-div-hidden' : ''}`}
      >
        <div
          className="active"
          style={pageName === 'home' ? { color: '#1549D0' } : {}}
          onClick={() => goPage('/m/home')}
        >
          首页
        </div>

        {/* 产品菜单 + 箭头 */}
        <div
          className="active product-item"
          style={
            pageName === 'result' || pageName === 'resultGs'
              ? { color: '#1549D0' }
              : {}
          }
          onClick={() => setProductOpen(!productOpen)}
        >
          <span>产品</span>
          <span className={`arrow ${productOpen ? 'arrow-open' : ''}`}></span>
        </div>

        {/* 展开内容 */}
        {productOpen && (
          <div className="sub-menu">
            <div
              style={pageName === 'result' ? { color: '#1549D0' } : {}}
              onClick={() => goPage('/m/result')}
            >
              智能报警施封锁
            </div>
            <div
              style={pageName === 'resultGs' ? { color: '#1549D0' } : {}}
              onClick={() => goPage('/m/resultGs')}
            >
              智能报警挂锁
            </div>
          </div>
        )}

        <div
          className="active"
          style={pageName === 'aboutus' ? { color: '#1549D0' } : {}}
          onClick={() => goPage('/m/aboutus')}
        >
          关于我们
        </div>
      </div>
    </>
  );
};

export default Header;
